// extracted by mini-css-extract-plugin
export default {"mainCont":"MainContainer_mainCont__fLRSx","scrollCont":"MainContainer_scrollCont__xF6MK","vidaGifCont":"MainContainer_vidaGifCont__UBsmO","vidaGif":"MainContainer_vidaGif__Fdw7I"};